import { render, staticRenderFns } from "./breadcrumb-list.component.vue?vue&type=template&id=44a27e62&scoped=true"
import script from "./breadcrumb-list.component.vue?vue&type=script&lang=ts"
export * from "./breadcrumb-list.component.vue?vue&type=script&lang=ts"
import style0 from "./breadcrumb-list.component.vue?vue&type=style&index=0&id=44a27e62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a27e62",
  null
  
)

export default component.exports